
import { defineComponent, ref, computed, watch } from "vue";
import { redesEnsino } from "@/core/listas/redesEnsino";
import { tipoAgrupamentoList } from "@/core/listas/tipoAgrupamentoList";
import InputSelect from "@/components/Inputs/InputSelect/InputSelect.vue";

export default defineComponent({
  name: "Agrupamento",
  components: { InputSelect },
  props: {
    modelValue: {
      type: [String, Number],
      required: false,
      default: "",
    },
    redeEnsino: {
      type: [String, Number],
      required: false,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const agrupamento = ref(props.modelValue || "");

    const REDE_ESTADUAL = computed(
      () => redesEnsino.find((r) => r.label === "Estadual")?.value
    );

    const REDE_MUNICIPAL = computed(
      () => redesEnsino.find((r) => r.label === "Municipal")?.value
    );

    //as opções do combo são exibidas a partir do valor selecionado em redeEnsino
    const agrupamentoFiltrado = computed(() => {
      if (props.redeEnsino == REDE_ESTADUAL.value) {
        return tipoAgrupamentoList.filter(
          (item) => item.label === "Capital" || item.label === "Interior"
        );
      }

      if (props.redeEnsino == REDE_MUNICIPAL.value) {
        return tipoAgrupamentoList.filter(
          (item) => item.label === "Por Município"
        );
      }

      return [];
    });

    const onChange = () => {
      emit("update:modelValue", agrupamento.value);
    };

    watch(
      () => props.modelValue,
      (newValue) => {
        agrupamento.value = newValue;
      }
    );

    watch(
      () => props.redeEnsino,
      () => {
        agrupamento.value = "";
        emit("update:modelValue", "");
      }
    );

    return {
      agrupamento,
      agrupamentoFiltrado,
      onChange,
    };
  },
});
